import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminApi } from '@/lib/api';
import { useLanguage } from '@/contexts/LanguageContext';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { ShieldCheck } from 'lucide-react';
import { toast } from 'sonner';

export default function AdminLoginPage() {
  const { t } = useLanguage();
  const nav = useNavigate();
  const [email, setEmail] = useState('admin@concordefinancial.com');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await adminApi.post('/admin/auth/login', { email, password });
      localStorage.setItem('concorde_admin_token', r.data.token);
      toast.success('Signed in');
      nav('/admin');
    } catch (err) { toast.error(err.response?.data?.detail || 'Login failed'); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--brand-navy-2))] p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-6 text-white">
          <div className="inline-flex items-center gap-2">
            <div className="h-10 w-10 rounded-lg bg-[hsl(var(--brand-gold))] text-[hsl(var(--brand-ink))] flex items-center justify-center font-serif text-lg">C</div>
            <div className="font-serif text-xl">Concorde Financial</div>
          </div>
          <div className="text-xs uppercase tracking-widest text-white/60 mt-2">Staff Portal</div>
        </div>
        <Card className="bg-white">
          <CardContent className="p-8">
            <div className="flex items-center gap-2 mb-4">
              <ShieldCheck className="h-5 w-5 text-[hsl(var(--brand-gold))]" />
              <h1 className="font-serif text-2xl text-[hsl(var(--brand-navy-2))]">{t('admin.login_title')}</h1>
            </div>
            <form onSubmit={submit} className="space-y-4">
              <div><Label>{t('auth.email')}</Label><Input required type="email" data-testid="admin-login-email" value={email} onChange={e => setEmail(e.target.value)} /></div>
              <div><Label>{t('auth.password')}</Label><Input required type="password" data-testid="admin-login-password" value={password} onChange={e => setPassword(e.target.value)} /></div>
              <Button type="submit" disabled={busy} data-testid="admin-login-submit" className="w-full bg-[hsl(var(--brand-navy))] hover:bg-[hsl(var(--brand-navy-2))]">{t('auth.submit_login')}</Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
